import { render, staticRenderFns } from "./moneyOrder.vue?vue&type=template&id=254eb669&scoped=true"
import script from "./moneyOrder.vue?vue&type=script&lang=js"
export * from "./moneyOrder.vue?vue&type=script&lang=js"
import style0 from "./moneyOrder.vue?vue&type=style&index=0&id=254eb669&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254eb669",
  null
  
)

export default component.exports